import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
// Escrita (request): 'tarjeta' deixou de ser método aceito (#159 B2).
export const RecaudacionMetodoPagoSchema = z.enum(['efectivo', 'transferencia', 'cheque']);
// Leitura (response): recaudaciones legadas migradas podem ter metodoPago='tarjeta'.
// O schema de OUTPUT aceita o valor legado read-only (escrita segue bloqueada).
export const RecaudacionMetodoPagoOutputSchema = z.enum(['efectivo', 'transferencia', 'cheque', 'tarjeta']);
export const RecaudacionEstadoSchema = z.enum(['registrada', 'confirmada', 'anulada']);
export const RecaudacionSchema = z.object({
    id: UuidSchema,
    clienteId: UuidSchema.nullable(),
    sucursalId: UuidSchema.nullable(),
    usuarioCobroId: UuidSchema.nullable(),
    monto: DecimalLikeSchema,
    fechaCobro: IsoDateTimeSchema.nullable(),
    metodoPago: RecaudacionMetodoPagoOutputSchema.nullable(),
    estado: RecaudacionEstadoSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateRecaudacionRequestSchema = z.object({
    clienteId: UuidSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    monto: DecimalLikeSchema,
    fechaCobro: IsoDateTimeSchema.nullable().optional(),
    metodoPago: RecaudacionMetodoPagoSchema.optional(),
    estado: RecaudacionEstadoSchema.optional(),
});
export const UpdateRecaudacionRequestSchema = z.object({
    clienteId: UuidSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    monto: DecimalLikeSchema.optional(),
    fechaCobro: IsoDateTimeSchema.nullable().optional(),
    metodoPago: RecaudacionMetodoPagoSchema.optional(),
    estado: RecaudacionEstadoSchema.optional(),
});
export const RecaudacionListQuerySchema = PaginationSchema.extend({
    clienteId: UuidSchema.optional(),
    sucursalId: UuidSchema.optional(),
    estado: RecaudacionEstadoSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
//# sourceMappingURL=recaudacion.js.map